import type { ShiftNotificationCreateInput,ShiftNotificationPage,ShiftNotificationQuery } from 'shared-models';
import { createShiftJsonClient } from '../http/shift-json-client';

const request=createShiftJsonClient('אין תקשורת לשרת.');
export const shiftNotificationsService={
  list:(query:ShiftNotificationQuery={}) => request<ShiftNotificationPage>(`/shift/notifications?offset=${query.offset ?? 0}&limit=${query.limit ?? 20}`),
  create:(input:ShiftNotificationCreateInput) => request<void>('/shift/notifications',{method:'POST',body:JSON.stringify(input)}),
  markRead:(id:number) => request<void>(`/shift/notifications/${id}/read`,{method:'PATCH'}),
};